module.exports = __webpack_public_path__ + "static/media/preview-thumbnail-1.010fd71a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/pseudodocs/preview-thumbnail-1.jpg
// module id = 1887
// module chunks = 2